import { render, staticRenderFns } from "./tCustomer.vue?vue&type=template&id=12731d75&scoped=true"
import script from "./tCustomer.vue?vue&type=script&lang=js"
export * from "./tCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12731d75",
  null
  
)

export default component.exports